(() => {
  const SELECTOR = '[data-bha-products]';
  const VERSION = 'v2.5';
  const rankedHandles = [
    'open-range-poultry-grain-mix','barastoc-golden-yolk-20kg','ecopet-kangaroo-mince','prime-100-kangaroo-and-pumpkin','green-valley-wild-bird-mix-20kg','eggs-4-sure-20kg-reids','wood-shavings-14kg','ecopet-beef-mince','green-valley-hobby-farm-mix','prime-100-chicken-veg-2kg','hi-lay-mash-20kg','prime-100-beef-veg-3kg','hygain-allrounder-cool-conditioning-feed-20kg','prime-100-chicken-veg-3kg','ecopet-beef-diced','xtra-egg-premium-seventeen-20kg','johnsons-fibre-safe-order-only-20kg','prime-100-salmon-tapioca-2kg','pea-straw-bale','prime-100-turkey-flaxseed','johnsons-horse-pony-20kg','rabbit-and-guinea-pig-mix','prime-100-chicken-and-brown-rice-2kg','prime-100-kangaroo-and-potato','monds-everyday-layer-feed-20kg','barastoc-heifer-developer-pellets-20kg','open-range-premium-grain-pellet-with-probiotics','green-valley-premium-black-sunflower-3-sizes','laucke-red-hen-free-range-layer-grain-20kg','hygain-fibressential-nutritionally-enhanced-chaff-nuggets','dogpro-true-value-20kg','hygain-equine-senior-horse-feed','mitavite-gumnuts-20kg','breeders-choice-recycled-paper','johnsons-every-horse-weight-gain-20kg','prime-100-beef-veg-2kg','prime-100-aussie-snapper-17kg','elite-pelletized-pine-cat-litter-15kg','barastoc-chick-starter-crumble-20kg','laucke-red-hen-layer-grain-pellet-mix-20kg','laucke-ewe-and-lamb-nuts-20kg','new-open-range-complete-poultry-mix-20kg','barastoc-champion-layer-20kg','open-range-starter-grower-mash-0-16-weeks-with-pron8ture','prime-kangaroo-vegetable-3kg','laucke-red-hen-premium-seventeen-crumble-20kg','farmers-mates-for-pets-chicken-2kg','farmers-mates-for-pets-beef-2kg','supervite-adult-beef','barastoc-rumevite-sheep-cattle-cubes-20kg'
  ];
  const escapeHtml = value => String(value ?? '').replace(/[&<>'\"]/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','\"':'&quot;'}[ch]));
  const money = value => new Intl.NumberFormat('en-AU',{style:'currency',currency:'AUD'}).format(Number(value || 0));
  const everydayVariants = product => {
    const variants = (product.variants || []).filter(v => v.available && Number.isFinite(Number(v.price)));
    const named = variants.filter(v => /everyday|shelf/i.test(v.title));
    if (named.length) return named;
    const tags = (Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',')).map(t => t.trim().toLowerCase());
    if (!tags.includes('everyday')) return [];
    return variants.filter(v => !/pre[\s-]?order|order[\s-]?in|special|bulk|bundle|pack of|[2-9]\s*x/i.test(v.title));
  };
  const sizedImage = value => {
    const src = String(value || '');
    if (!src) return '';
    try {
      const url = new URL(src, window.location.origin);
      if (url.hostname.endsWith('cdn.shopify.com')) {
        url.searchParams.set('width', '420');
        return url.toString();
      }
    } catch (_) {}
    return src;
  };
  const randomInt = max => {
    if (max <= 1) return 0;
    if (window.crypto && crypto.getRandomValues) {
      const values = new Uint32Array(1);
      crypto.getRandomValues(values);
      return values[0] % max;
    }
    return Math.floor(Math.random() * max);
  };
  const shuffle = list => {
    const a = list.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = randomInt(i + 1);
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  };
  const fetchProduct = async handle => {
    const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, {credentials:'same-origin'});
    if (!response.ok) throw new Error(handle);
    return response.json();
  };
  async function buildPicks() {
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    const count = mobile ? 8 : 12;
    const device = mobile ? 'mobile' : 'desktop';
    const historyKey = `baroona-popular-${VERSION}-${device}`;
    let recent = [];
    try {
      recent = JSON.parse(sessionStorage.getItem(historyKey) || '[]');
      if (!Array.isArray(recent)) recent = [];
    } catch (_) { recent = []; }
    const recentSet = new Set(recent);
    const candidates = shuffle(rankedHandles.filter(h => !recentSet.has(h)))
      .concat(shuffle(rankedHandles.filter(h => recentSet.has(h))))
      ;
    const products = [];
    for (let i = 0; i < candidates.length && products.length < count; i += 4) {
      const batch = candidates.slice(i, i + 4);
      const settled = await Promise.allSettled(batch.map(fetchProduct));
      settled.forEach(result => {
        if (result.status === 'fulfilled' && products.length < count) {
          const p = result.value;
          if (p && p.handle && p.title && Array.isArray(p.variants) && p.variants.length && everydayVariants(p).length) products.push(p);
        }
      });
    }
    if (!products.length) throw new Error('No ranked products loaded');
    const nextHistory = products.map(p => p.handle).concat(recent).filter((h,i,a) => a.indexOf(h) === i).slice(0, count * 3);
    try { sessionStorage.setItem(historyKey, JSON.stringify(nextHistory)); } catch (_) {}
    return products;
  }
  function render(grid, products) {
    grid.innerHTML = products.map(product => {
      const image = sizedImage(product.featured_image || product.images?.[0] || '');
      const prices = everydayVariants(product).map(v => Number(v.price)).filter(Number.isFinite);
      const price = Math.min(...prices) / 100;
      const from = new Set(prices).size > 1 ? (document.querySelector('[data-baroona-from-label]')?.dataset.baroonaFromLabel || '') : '';
      return `<a class=\"bha__product\" href=\"/products/${encodeURIComponent(product.handle)}\"><span class=\"bha__product-media\">${image ? `<img src=\"${escapeHtml(image)}\" alt=\"\" loading=\"lazy\" decoding=\"async\" width=\"420\" height=\"420\">` : ''}</span><span class=\"bha__product-copy\"><span class=\"bha__product-vendor\">${escapeHtml(product.vendor || '')}</span><strong>${escapeHtml(product.title)}</strong><b>${escapeHtml(from)}${from ? ' ' : ''}${money(price)}</b><span class=\"bha__everyday\">Everyday</span></span></a>`;
    }).join('');
    grid.dataset.baroonaPopularVersion = VERSION;
  }
  async function initialise() {
    const grids = Array.from(document.querySelectorAll(SELECTOR));
    if (!grids.length) return;
    try {
      const products = await buildPicks();
      grids.forEach(grid => render(grid, products));
    } catch (error) {
      console.warn('Baroona Popular Picks V2.4:', error);
      grids.forEach(grid => { if (!grid.children.length || grid.querySelector('.bha__loading')) grid.innerHTML = '<div class=\"bha__loading\">Popular picks are being refreshed.</div>'; });
    }
  }
  const start = () => {
    if ('requestIdleCallback' in window) requestIdleCallback(initialise, {timeout: 1800});
    else setTimeout(initialise, 500);
  };
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, {once:true});
})();
